<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    @if(shouldShowSearch()) {
      <app-searchable-select
        [applyClass]="formControl.invalid ? 'error' : ''"
        [options]="getOptions()"
        [placeholder]="field.props['placeholder'] || ('COMMON.SELECT_OPTION' | translate)"
        [required]="field.props['required'] || false"
        [disabled]="options.formState.disabled || field.props['disabled'] || field.props['readonly']"
        [filterBy]="field.props['filterBy'] || 'label'"
        [value]="formControl.value"
        (valueChange)="onSearchValueChange($event)">
      </app-searchable-select>
    } @else {
      <select class="select"
        [class.error]="formControl.invalid"
        [formControl]="$any(formControl)" 
        [formlyAttributes]="field"
        title="{{`${this.field.props['formName']}.${this.field.key}.placeholder` | translate  }}"
        (change)="onValueChange($event)">
        @if(field.props['placeholder']) {
          @if(field.props['required']) {
            <option class="select-option" value=undefined selected disabled>{{`${this.field.props.placeholder}` | translate  }}</option>
          } @else {
            <option class="select-option" value=undefined selected>{{`${this.field.props.placeholder}` | translate  }}</option>
          }
        } @else {
          @if(field.props['required']) {
            <option class="select-option" value=undefined selected disabled>{{ 'COMMON.SELECT_OPTION' | translate }}</option>
          } @else {
            <option class="select-option" value=undefined selected>{{ 'COMMON.SELECT_OPTION' | translate }}</option>
          } 
        }
        @for(option of $any(getOptions()); track $index) {
          <option class="select-option"
            [value]="option.value || option.code">
            {{ (option.label || option.value || option.code) | translate }}
          </option>
        }
      </select>
    }
  } @else {
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      {{getLabel(formControl.value || "")}}
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>